import { watch, onMounted, onBeforeUnmount } from 'vue';
import useLifecycleHook from '@/compositions/useLifecycleHook.js';

export default function useEventListener(event, callback, options = {}) {
  const o = { targetRef: null, targetElem: null, useCapture: false, ...options };

  const getTarget = () => {
    if (o.targetRef) {
      return o.targetRef.value;
    }
    if (o.targetElem) {
      return o.targetElem;
    }
    return window;
  };

  if (o.targetRef) {
    watch(o.targetRef, (next, prev) => {
      if (prev) {
        prev.removeEventListener(event, callback, o.useCapture);
      }
      if (next) {
        next.addEventListener(event, callback, o.useCapture);
      }
    });
  }

  onMounted(() => {
    const target = getTarget();
    if (target) {
      target.addEventListener(event, callback, o.useCapture);
    }
  });
  onBeforeUnmount(() => {
    const target = getTarget();
    if (target) {
      target.removeEventListener(event, callback, o.useCapture);
    }
  });
}
